import React from 'react';

const AyurvedicHerbsPage = () => {
  return (
    <div className="container mx-auto py-12 px-4 bg-gray-100 font-sans">
        
      <h1 className="text-4xl font-bold text-center mb-12 uppercase text-[#4a6b2e]">Taking Your Herbs</h1>
      
      {/* Articles Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        
        {/* Article 1: How to Take Herbal Tablets */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img src="https://homesteadingfamily.com/wp-content/uploads/2023/03/Herb-Capsules_HF.jpg" alt="Herbal tablets" className="w-full h-56 object-cover" />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Ayurveda / Taking Your Herbs</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">How to Take Herbal Tablets</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              If you haven't taken herbal tablets before, getting started can feel overwhelming. This guide will address some common questions about taking herbal tablets.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>

        {/* Article 2: Your Guide to Herbal Ghees */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img src="https://thecoconutmama.com/wp-content/uploads/2023/10/Olive-Oil-vs-Ghee-The-Ultimate-Verdict-jpg.webp" alt="Ghee jars" className="w-full h-56 object-cover" />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Ayurveda / Taking Your Herbs</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Your Guide to Herbal Ghees: What They Are and How to Use Them</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Ghee is most commonly known as a cooking ingredient—a healthy alternative to butter and oil that has a creamy texture and a buttery taste. However, the use and benefits of...
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>

        {/* Article 3: Drink Your Herbs */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img src="https://gardenerspath.com/wp-content/uploads/2022/03/Herbal-Tea-Feature.jpg" alt="Herbal teas" className="w-full h-56 object-cover" />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Ayurveda / Taking Your Herbs</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Drink Your Herbs: The Benefits of Herbal Teas and Drinks</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Warm drinks are one of life's most beloved pleasures. Along with many benefits, sipping a warm beverage helps us slow down and notice the beauty of the moment.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>
        
        {/* Article 4: Placeholder for next article */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img src="https://keralaayurveda.biz/cdn/shop/articles/unnamed_f29369c2-6cc1-481f-94ec-a67744ea6180.jpg?v=1751349030&width=1500" alt="Herbal jars" className="w-full h-56 object-cover" />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Ayurveda / Taking Your Herbs</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">A Guide to Ayurvedic Herbs</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Explore the rich world of Ayurvedic herbs and their specific benefits for balancing each dosha.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>
        
        {/* Article 5: Placeholder for next article */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img src="https://s3.us-east-2.amazonaws.com/homestead.org/wp-content/uploads/2023/06/Cooking-with-Fresh-Herbs-from-Your-Garden.jpg" alt="Spices" className="w-full h-56 object-cover" />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Ayurveda / Taking Your Herbs</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Using Herbs in Your Cooking</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Learn how to incorporate medicinal herbs and spices into your daily meals to enhance flavor and promote digestive health.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>
        
        {/* Article 6: Placeholder for next article */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img src="https://pharmaceutical-journal.com/wp-content/uploads/2021/01/herbal-medicines-ss-18-scaled.jpg" alt="Plant" className="w-full h-56 object-cover" />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Ayurveda / Taking Your Herbs</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Herbs for a Healthy Mind</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Discover powerful adaptogenic herbs that support mental clarity, reduce stress, and improve focus in your daily life.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default AyurvedicHerbsPage;